import React from 'react'
import { Link } from 'react-router-dom'
import { Query, graphql, compose } from 'react-apollo'
import moment from 'moment'

import miniMe from 'graphql/queries/miniMe'
import azioni from 'graphql/queries/azioni'
import updateAzione from 'graphql/mutations/updateAzione'

import Alarm from 'material-ui-icons/Alarm'
import Close from 'material-ui-icons/Close'

import IconCard from 'components/Cards/IconCard.jsx'
import withStyles from 'material-ui/styles/withStyles'
import Table from 'material-ui/Table'
import TableHead from 'material-ui/Table/TableHead'
import TableCell from 'material-ui/Table/TableCell'
import TableBody from 'material-ui/Table/TableBody'
import TableRow from 'material-ui/Table/TableRow'
import IconButton from 'material-ui/IconButton'

import tableStyle from 'assets/jss/material-dashboard-pro-react/components/tableStyle.jsx'


class Promemoria extends React.Component {
  
  dismissPromemoria = (promemoria, myId) => event => {
    event.preventDefault()
    this.props.updateAzione({
      variables: {
        id: promemoria.id,
        azione: {
          promemoriaDismesso: true,
        },
      },
      refetchQueries: [
        {
          query: azioni,
          variables: {
            limit: 200,
            where: {
              tipoAzioneId: 8,
              promemoriaDismesso: false,
              promemoriaUtenteId: myId
            },
            orderBy: "promemoriaDataOra_ASC"
          }
        }
      ]
    })
    .then(({ data }) => {
      console.log(data)
    })
    .catch(error => {
      console.log(error.message)
    })
  }
  
  render() {
    const { classes } = this.props

    return (
      <div className="elenco-promemoria">
        <IconCard
          icon={Alarm}
          iconColor="blue"
          title="Promemoria attivi"
          content={
            <Query query={miniMe}>
              {({ loading, error, data: { me } }) => {
                if (loading) return <p>Loading...</p>
                if (error) return <p>Error :(</p>

                const myId = me.id
                
                return (
                  <Query
                    query={azioni}
                    variables={{
                      limit: 200,
                      where: {
                        tipoAzioneId: 8,
                        promemoriaDismesso: false,
                        promemoriaUtenteId: myId
                      },
                      orderBy: "promemoriaDataOra_ASC"
                    }}
                    fetchPolicy="cache-and-network"
                  >
                    {({ loading, error, data: { azioni } }) => {
                      if (loading) return <p>Loading...</p>
                      if (error) return <p>Error :(</p>

                      const promemoria = azioni.nodes

                      return (
                        promemoria.length > 0 ?
                          <Table className={classes.table}>
                            <TableHead>
                              <TableRow>
                                <TableCell className={classes.tableHeadCell}>Nome</TableCell>
                                <TableCell className={classes.tableHeadCell}>Comune</TableCell>
                                <TableCell className={classes.tableHeadCell}>Telefono</TableCell>
                                <TableCell className={classes.tableHeadCell}>Descrizione</TableCell>
                                <TableCell className={classes.tableHeadCell}>Data Ora</TableCell>
                                <TableCell className={classes.tableHeadCell}></TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {promemoria.map(p => (
                                <TableRow key={p.id}>
                                  <TableCell className={classes.tableCell}><Link to={`/clienti/${p.cliente.id}`}><b>{p.cliente.nome ? p.cliente.nome : <i>Senza nome</i>}</b></Link></TableCell>
                                  <TableCell className={classes.tableCell}>{p.cliente.comune}</TableCell>
                                  <TableCell className={classes.tableCell}><a href={`tel:${p.cliente.telefono}`}>{p.cliente.telefono}</a></TableCell>
                                  <TableCell className={classes.tableCell}>{p.descrizione}</TableCell>
                                  <TableCell className={classes.tableCell}>{moment(p.promemoriaDataOra).format('DD/MM/YYYY HH:mm')}</TableCell>
                                  <TableCell className={classes.tableCell}><IconButton color="primary" style={{ float: 'right', fontSize: '16px', width: 20, height: 20 }} onClick={this.dismissPromemoria(p, myId)} title="Disattiva promemoria"><Close /></IconButton></TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        :
                          <h4>Nessun promemoria attivo</h4>
                      )
                    }}
                  </Query>
                )
              }}
            </Query>
          }
        />
      </div>
    )
  }
}

export default compose (
  withStyles(tableStyle),
  graphql(updateAzione, { name: 'updateAzione' })
)(Promemoria)


// WEBPACK FOOTER //
// ./src/views/App/Promemoria/Promemoria.jsx